import React from "react";
import {
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
} from "@mui/material";

function CompanyInfo() {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell
              style={{ textAlign: "center", fontWeight: "bold" }}
              colSpan={2}
            >
              Payment Methods
            </TableCell>
          </TableRow>

          <TableCell
            style={{
              textAlign: "center",
              marginBottom: "auto",
            }}
            colSpan={2}
          >
            <p>
              IF YOUR PAYMENT IS VIA WIRE/ACH TRANSFER OR ZELLE PLEASE MAKE SURE
              TO ADD THIS INVOICE # TO YOUR PAYMENT REFERENCE NOTES
            </p>
          </TableCell>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell
              style={{
                width: "50%",
                flexDirection: "column",
              }}
            >
              <h4
                style={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  marginBottom: "auto",
                }}
              >
                Direct deposit and ACH
              </h4>
              <p>
                Global Transit Solutions LLC <br></br> <b>Bank:</b> Chase Bank{" "}
                <br></br> <b>Account Number:</b> 530532616 <br></br>{" "}
                <b>Routing:</b> 322271627 <br></br> 5600 Wilshire blvd 01 Los
                Angeles, CA 90036
              </p>
            </TableCell>
            <TableCell
              style={{
                width: "50%",
              }}
            >
              <h4
                style={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  marginBottom: "auto",
                }}
              >
                Wire transfers / International transfers
              </h4>
              <p>
                Global Transit Solutions LLC <br></br> <b>Bank:</b> Chase Bank{" "}
                <br></br> <b>Account Number:</b> 530532616 <br></br>{" "}
                <b>Routing:</b> 021000021 <br></br> <b>Swift Code:</b> CHASUS33
                <br></br> 5600 Wilshire blvd 01 Los Angeles, CA 90036
              </p>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableRow>
          <TableCell
            style={{
              textAlign: "left",
              marginBottom: "auto",
            }}
          >
            <p>
              <b> Zelle: </b> admin@globaltransitsol.com <br></br>{" "}
              <b>Credit / Debit Cards:</b> We take all cards at a 4% processing
              fee
            </p>
          </TableCell>
        </TableRow>
      </Table>
    </TableContainer>
  );
}

export default CompanyInfo;
